export const environment = {
  production: false,
  name: 'Dev',
  applicationName: 'MCC',
  apiUrl: 'https://moncompte.codir.local:56971/',
  apiUrlPrefix: '',
  angularUrl: 'https://moncompte.codir.local:4201/',
  localStorageAesKey: '',
  encryptStorage: false,
  version: '2.0',
  useSimulation: true,
  disableBetaRedirect: false,
  SSO: {
    path: 'https://sso-rec.krys-group.com',
    wsPath: 'https://sso-ws-rec.krys-group.com',
    clientId: '60a20bb1902f44bf4cdf9a12971bc0e5nh6wx1f9nxi77i1qrl',
    unikPath: 'https://unik-rec.krys-group.com'
  },
  tickets: {
    m42SiteUrl: 'https://krys.m42cloud.com/wm/app-SelfServicePortal/search-page/7b37775e-e4f9-e611-e282-7824af3d4067/filter/267ed834-3a9e-4eea-af9d-3d9c59971776',
    CDOCustomerServiceEmail: 'serviceclients.cdo@codir.fr',
    CDACustomerServiceEmail: 'serviceclients.audio@codir.fr',
    HECustomerServiceEmail: 'service-clients-codir@krys-group.com',
    SECustomerServiceEmail: 'service-clients-codir@krys-group.com'
  }
};
